"use strict";
exports.__esModule = true;
exports.OnboardingPropertyCountPagePropertyOnboardingContextManifestV1 = {
    ids: {
        app_data: 'property-onboarding',
        context_version: 1,
        page_type_id: 20008
    }
};
exports.WebOnboardingPropertyCountVisitEventPropertyOnboardingManifestV1 = {
    ids: {
        action_type: 'visit',
        app_data: 'property-onboarding',
        event_version: 1,
        page_type_id: 20008
    }
};
